import type { ComponentProps } from "react";

import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";

type ExportToSalesforceDropdownItemProps = Pick<
    ComponentProps<typeof ExportVariantsDropdownItem>,
    "isDisabled" | "isUseLockedIcon" | "text" | "tooltipContent" | "tooltipDisabledContent" | "onClick"
>;

const ExportToSalesforceDropdownItem = (props: ExportToSalesforceDropdownItemProps) => {
    return (
        <ExportVariantsDropdownItem
            {...props}
            iconName="salesforce"
            variant="salesforce"
        />
    );
};

export default ExportToSalesforceDropdownItem;
